import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { GlobalHelper } from '../Common/global.service';


@Injectable({
  providedIn: 'root'
})
export class LearningService {

  constructor(private globalHelper: GlobalHelper, private httpclient: HttpClient) { }

  //Learning Book Title------------------------------------------------------------------
  
  GetAllLearningBookTitle(strdata): Observable<any> {
    var param = 'ObjModel=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'Learning/GetAllLearningBookTitle?' + encodeURI(param), { headers: reqHeader });
  }

  SaveLearningBookTitle(strdata): Observable<any> {
    var param = 'ObjModel=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'Learning/SaveLearningBookTitle?' + encodeURI(param), { headers: reqHeader });
  }

  MarkActiveLearningBookTitle(strdata): Observable<any> {
    var param = 'ObjModel=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'Learning/MarkActiveLearningBookTitle?' + encodeURI(param), { headers: reqHeader });
  }

  //Chapter Heading------------------------------------------------------------------
  
  GetAllChapterHeading(BookTitleID): Observable<any> {
    var param = 'BookTitleID=' + BookTitleID;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'Learning/GetAllChapterHeading?' + encodeURI(param), { headers: reqHeader });
  }

  SaveChapterHeading(strdata): Observable<any> {
    var param = 'ObjModel=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'Learning/SaveChapterHeading?' + encodeURI(param), { headers: reqHeader });
  }

  MarkActiveChapterHeading(strdata): Observable<any> {
    var param = 'ObjModel=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'Learning/MarkActiveChapterHeading?' + encodeURI(param), { headers: reqHeader });
  }

  //Chapter Topic------------------------------------------------------------------
  
  GetAllChapterTopic(ChapterID): Observable<any> {
    var param = 'ChapterID=' + ChapterID;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'Learning/GetAllChapterTopic?' + encodeURI(param), { headers: reqHeader });
  }

  SaveChapterTopic(strdata): Observable<any> {
    var param = 'ObjModel=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'Learning/SaveChapterTopic?' + encodeURI(param), { headers: reqHeader });
  }

  MarkActiveChapterTopic(strdata): Observable<any> {
    var param = 'ObjModel=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'Learning/MarkActiveChapterTopic?' + encodeURI(param), { headers: reqHeader });
  }


  //Chapter Content------------------------------------------------------------------
  
  GetAllChapterContent(strdata): Observable<any> {
    var param = 'ObjModel=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'Learning/GetAllChapterContent?' + encodeURI(param), { headers: reqHeader });
  }

  SaveChapterContent(strdata,Content): Observable<any> {
    let formData = new FormData();
    formData.append("ObjModel", strdata);
    formData.append("Content", Content);
    // for (var i = 0; i < file.length; i++) {
    //   formData.append("ContentFile" + i, file[i]);
    // }
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Learning/SaveChapterContent', formData);
    // var param = 'ObjModel=' + strdata;
    // var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
    //   'Learning/SaveChapterContent?' + encodeURI(param), { headers: reqHeader });
  }

  MarkActiveChapterContent(strdata): Observable<any> {
    var param = 'ObjModel=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'Learning/MarkActiveChapterContent?' + encodeURI(param), { headers: reqHeader });
  }

   // Content Resource

   SaveContentResource(strdata,file): Observable<any> {
    let formData = new FormData();
    formData.append("ObjModel", strdata);   
    formData.append("ContentFile", file);    
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Learning/SaveContentResource', formData);
   
  }

  DeleteContentResource(ResourceID): Observable<any> {
    var param = 'ResourceID=' + ResourceID;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'Learning/DeleteContentResource?' + encodeURI(param), { headers: reqHeader });
  }
  
  GetAllContentResource(TopicID): Observable<any> {
    var param = 'TopicID=' + TopicID;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'Learning/GetAllContentResource?' + encodeURI(param), { headers: reqHeader });
  }

  MarkShareTopicResourse(ResourceID,IsShared): Observable<any> {
    var param = 'ResourceID=' + ResourceID+'&IsShared=' + IsShared;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'Learning/MarkShareTopicResourse?' + encodeURI(param), { headers: reqHeader });
  }

   //Class Book Title Map------------------------------------------------------------------
  
   MarkActiveClassBookTitle(strdata): Observable<any> {
    var param = 'ObjModel=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'Learning/MarkActiveClassBookTitle?' + encodeURI(param), { headers: reqHeader });
  }

  SaveClassBookTitleMapping(strdata): Observable<any> {
     var param = 'ObjModel=' + strdata;
     var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
       'Learning/SaveClassBookTitleMapping?' + encodeURI(param), { headers: reqHeader });
  }

  GetAllClassBookTitleMapping(strdata): Observable<any> {
    var param = 'ObjModel=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'Learning/GetAllClassBookTitleMapping?' + encodeURI(param), { headers: reqHeader });
  }

  // Learning Teaching

  SaveLearningTeaching(strdata,Content,ClassSectionList): Observable<any> {
    let formData = new FormData();
    formData.append("ObjModel", strdata);
    formData.append("Content", Content);
    formData.append("ClassSectionList", ClassSectionList);
    
    
    // for (var i = 0; i < file.length; i++) {
    //   formData.append("ContentFile" + i, file[i]);
    // }
    
    // for (var i = 0; i < WorkSheetFile.length; i++) {
    //   formData.append("WorkSheetFile" + i, WorkSheetFile[i]);
    // }
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Learning/SaveLearningTeaching', formData);
   
  }


  GetAllLearningTeaching(strdata): Observable<any> {
    var param = 'ObjModel=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'Learning/GetAllLearningTeaching?' + encodeURI(param), { headers: reqHeader });
  }
  GetAllTeaching(strdata): Observable<any> {
    var param = 'ObjModel=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'Learning/GetAllTeaching?' + encodeURI(param), { headers: reqHeader });
  }
 

  MarkActiveLearningTeaching(strdata): Observable<any> {
    var param = 'ObjModel=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'Learning/MarkActiveLearningTeaching?' + encodeURI(param), { headers: reqHeader });
  }

    // Teaching Resource

    SaveTeachingResource(strdata,file,TeachingID): Observable<any> {
      let formData = new FormData();
      formData.append("ObjModel", strdata);       
      formData.append("ContentFile", file); 
      formData.append("TeachingID", TeachingID); 
      return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Learning/SaveTeachingResource', formData);
     
    }
  
    DeleteTeachingResource(TeachingResourceID): Observable<any> {
      var param = 'TeachingResourceID=' + TeachingResourceID;
      var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
        'Learning/DeleteTeachingResource?' + encodeURI(param), { headers: reqHeader });
    }
    
    GetAllTeachingResource(TeachingID): Observable<any> {
      var param = 'TeachingID=' + TeachingID;
      var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
        'Learning/GetAllTeachingResource?' + encodeURI(param), { headers: reqHeader });
    }

    MarkShareTeachingResourse(TeachingResourceID,IsShared): Observable<any> {
      var param = 'TeachingResourceID=' + TeachingResourceID+'&IsShared=' + IsShared;
      var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
        'Learning/MarkShareTeachingResourse?' + encodeURI(param), { headers: reqHeader });
    }

    GetPreviousTeaching(strdata): Observable<any> {
      var param = 'ObjModel=' + strdata;
      var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
        'Learning/GetPreviousTeaching?' + encodeURI(param), { headers: reqHeader });
    }

    ImportLearningTeaching(ObjList): Observable<any> {
      let formData = new FormData();
      formData.append("ObjList", ObjList);    
      return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Learning/ImportLearningTeaching', formData);
     
    }
  
    SaveImportLearningTeaching(strdata,Content,ClassSectionList): Observable<any> {
      let formData = new FormData();
      formData.append("ObjModel", strdata);
      formData.append("Content", Content);
      formData.append("ClassSectionList", ClassSectionList);    
      return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Learning/SaveImportLearningTeaching', formData);
     
    }

  // Learning Tutorial

  SaveLearningTutorial(strdata,Content): Observable<any> {
    let formData = new FormData();
    formData.append("ObjModel", strdata);
    formData.append("Content", Content);
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Learning/SaveLearningTutorial', formData);
   
  }

  GetAllLearningTutorial(strdata): Observable<any> {
    var param = 'ObjModel=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'Learning/GetAllLearningTutorial?' + encodeURI(param), { headers: reqHeader });
  }

  MarkActiveLearningTutorial(strdata): Observable<any> {
    var param = 'ObjModel=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'Learning/MarkActiveLearningTutorial?' + encodeURI(param), { headers: reqHeader });
  }

    // Tutorial Resource

    SaveTutorialResource(strdata,file): Observable<any> {
      let formData = new FormData();
      formData.append("ObjModel", strdata);
      formData.append("ContentFile", file);   
     
      return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Learning/SaveTutorialResource', formData);
     
    }
  
    DeleteTutorialResource(strdata): Observable<any> {
      var param = 'ObjModel=' + strdata;
      var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
        'Learning/DeleteTutorialResource?' + encodeURI(param), { headers: reqHeader });
    }
    
    GetAllTutorialResource(strdata): Observable<any> {
      var param = 'ObjModel=' + strdata;
      var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
        'Learning/GetAllTutorialResource?' + encodeURI(param), { headers: reqHeader });
    }
// Learning WorkSheet

SaveWorksheet(strdata,strlist): Observable<any> {
  let formData = new FormData();  
  formData.append("ObjModel", strdata);
  formData.append("ObjList", strlist);
  return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Learning/SaveWorksheet', formData);
 
}

GetTopicQuestionBank(strdata): Observable<any> {
  var param = 'ObjModel=' + strdata;
  var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
    'Learning/GetTopicQuestionBank?' + encodeURI(param), { headers: reqHeader });
}

GetAllWorksheet(strdata): Observable<any> {
  var param = 'ObjModel=' + strdata;
  var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
    'Learning/GetAllWorksheet?' + encodeURI(param), { headers: reqHeader });
}

MarkActiveWorksheet(strdata): Observable<any> {
  var param = 'ObjModel=' + strdata;
  var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
    'Learning/MarkActiveWorksheet?' + encodeURI(param), { headers: reqHeader });
}

SaveTestInstruction(WorksheetID, Instruction): Observable<any> {
  let formData = new FormData();
  formData.append("WorksheetID", WorksheetID);
  formData.append("Instruction", Instruction);
  return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Learning/SaveTestInstruction', formData);
}

// Learning WorkSheet

SaveQuestionBank(strdata,file): Observable<any> {
  let formData = new FormData();
  formData.append("ObjModel", strdata);
  formData.append("ContentFile", file);  
  return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Learning/SaveQuestionBank', formData);
 
}

GetAllQuestionBank(strdata): Observable<any> {
  var param = 'ObjModel=' + strdata;
  var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
    'Learning/GetAllQuestionBank?' + encodeURI(param), { headers: reqHeader });
}

MarkActiveQuestionBank(strdata): Observable<any> {
  var param = 'ObjModel=' + strdata;
  var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
    'Learning/MarkActiveQuestionBank?' + encodeURI(param), { headers: reqHeader });
}

UploadQuestionBank(strdata,file): Observable<any> {
  let formData = new FormData();
  formData.append("ObjModel", strdata);
  formData.append("ContentFile", file);  
  return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Learning/UploadQuestionBank', formData);
 
}

UpdateQuestionBank(strdata,list): Observable<any> {
  let formData = new FormData();
  formData.append("ObjModel", strdata);
  formData.append("ObjList", list);  
  return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Learning/UpdateQuestionBank', formData);
 
}


GetOnlineTutorial(strdata): Observable<any> {
  var param = 'ObjModel=' + strdata;
  var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
    'Learning/GetOnlineTutorial?' + encodeURI(param), { headers: reqHeader });
  }
// Test Report

GetAllTestReport(strdata): Observable<any> {
  var param = 'ObjModel=' + strdata;
  var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
    'Learning/GetAllTestReport?' + encodeURI(param), { headers: reqHeader });

}

GetOnlineTeaching(strdata): Observable<any> {
  var param = 'filter=' + strdata;
  var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
    'Learning/GetOnlineTeaching?' + encodeURI(param), { headers: reqHeader });
}
GetOnlineTeachingTopic(strdata): Observable<any> {
  var param = 'filter=' + strdata;
  var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
    'Learning/GetOnlineTeachingTopic?' + encodeURI(param), { headers: reqHeader });
}
GetTeachingDetails(strdata): Observable<any> {
  var param = 'filter=' + strdata;
  var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
    'Learning/GetTeachingDetails?' + encodeURI(param), { headers: reqHeader });
}
GetOnlineTeachingDetails(strdata): Observable<any> {
  var param = 'filter=' + strdata;
  var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
    'Learning/GetOnlineTeachingDetails?' + encodeURI(param), { headers: reqHeader });
}

GetOnlineWorksheet(strdata): Observable<any> {
  var param = 'filter=' + strdata;
  var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
    'Learning/GetOnlineWorksheet?' + encodeURI(param), { headers: reqHeader });
}
GetOnlineWorksheetQuestion(strdata): Observable<any> {
  var param = 'filter=' + strdata;
  var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
    'Learning/GetOnlineWorksheetQuestion?' + encodeURI(param), { headers: reqHeader });
}
OnlineSaveTestQuestion(strdata): Observable<any> {
  var param = 'filter=' + strdata;
  var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
    'Learning/OnlineSaveTestQuestion?' + encodeURI(param), { headers: reqHeader });
}
OnlineSaveTestSubmit(strdata): Observable<any> {
  var param = 'filter=' + strdata;
  var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
    'Learning/OnlineSaveTestSubmit?' + encodeURI(param), { headers: reqHeader });
}
GetOnlineWorksheetHistory(strdata): Observable<any> {
  var param = 'filter=' + strdata;
  var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
    'Learning/GetOnlineWorksheetHistory?' + encodeURI(param), { headers: reqHeader });
}


GetAllTestWorksheet(strdata): Observable<any> {
  var param = 'ObjModel=' + strdata;
  var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
    'Learning/GetAllTestWorksheet?' + encodeURI(param), { headers: reqHeader });
}

TestReportDownload(strdata): Observable<any> {
  var param = 'ObjModel=' + strdata;
  var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
    'Learning/TestReportDownload?' + encodeURI(param), { headers: reqHeader });
}

GetAllTestQuestions(strdata): Observable<any> {
  var param = 'ObjModel=' + strdata;
  var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
    'Learning/GetAllTestQuestions?' + encodeURI(param), { headers: reqHeader });
}

// Learning Tutorial
CreateNewMeeting(request): Observable<any> {
 
  
  // return this.httpclient.post<any>(this.globalHelper.apiZoomUrl + 'zoomfeature/meetings', formData);
  return this.httpclient.post(`${this.globalHelper.apiZoomUrl}zoomfeature/meetings`, request)
}
delete(request): Observable<any> {
 
  return this.httpclient.post(`${this.globalHelper.apiZoomUrl}zoomfeature/delete`, request)
  // return this.httpclient.post<any>(this.globalHelper.apiZoomUrl + 'zoomfeature/meetings', formData);
  // return this.httpclient.post(`${this.globalHelper.apiZoomUrl}zoomfeature/delete(request): Observable<any> {
  //   `, request)
}
SaveLiveClass(strdata,Content): Observable<any> {
  let formData = new FormData();
  formData.append("ObjModel", strdata);
  formData.append("Content", Content);
  return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Learning/SaveLiveClass', formData);
 
}

GetAllLiveClass(strdata): Observable<any> {
  var param = 'ObjModel=' + strdata;
  var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
    'Learning/GetAllLiveClass?' + encodeURI(param), { headers: reqHeader });
}

MarkActiveLiveClass(strdata): Observable<any> {
  var param = 'ObjModel=' + strdata;
  var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
    'Learning/MarkActiveLiveClass?' + encodeURI(param), { headers: reqHeader });
}
CreateMeetingCode(strdata): Observable<any> {
  var param = 'ObjModel=' + strdata;
  var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
    'Learning/CreateMeetingCode?' + encodeURI(param), { headers: reqHeader });
}
GetStudentLiveClass(strdata): Observable<any> {
  var param = 'ObjModel=' + strdata;
  var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
    'Learning/GetStudentLiveClass?' + encodeURI(param), { headers: reqHeader });
}
}

